module.exports = __webpack_public_path__ + "img/middle.abe1f5d5.png";